/* NUTRILINQ cart: one-tap "Switch to Subscribe & Save" on one-time lines.
 * Changes the line's selling plan, then re-renders the drawer (or reloads the
 * cart page). Works for lines re-rendered later, via a delegated listener. */
(function () {
  if (window.__nlCart) return;
  window.__nlCart = true;

  // Right after switching to Subscribe & Save: pop the bar and count the savings up
  function celebrate() {
    var flag = null;
    try { flag = sessionStorage.getItem('nl-just-subscribed'); sessionStorage.removeItem('nl-just-subscribed'); } catch (err) {}
    if (!flag) return;
    document.querySelectorAll('.nl-ship').forEach(function (bar) {
      if (!bar.offsetParent) return;
      bar.classList.add('is-celebrating');
      var amt = bar.querySelector('[data-nl-amount]');
      if (!amt || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var cents = parseInt(amt.dataset.nlAmount, 10), t0 = performance.now(), final = amt.textContent;
      (function tick(now) {
        var k = Math.min(1, (now - t0) / 900), v = Math.round(cents * (1 - Math.pow(1 - k, 3)));
        amt.textContent = k < 1 ? '$' + (v / 100).toFixed(2) : final;
        if (k < 1) requestAnimationFrame(tick);
      })(t0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', celebrate); else celebrate();

  // "Switch to Subscribe & Save" for the whole cart: change each one-time line (by key) in turn
  document.addEventListener('click', function (e) {
    var all = e.target.closest('[data-nl-upgrade-all]');
    if (!all) return;
    e.preventDefault();
    all.disabled = true;
    all.classList.add('is-loading');
    var drawer = all.closest('cart-drawer');
    var jobs = all.dataset.nlUpgradeAll.split(',').filter(Boolean).map(function (s) { var p = s.split('|'); /* keys contain ':' */ return { id: p[0], selling_plan: parseInt(p[1], 10), quantity: parseInt(p[2], 10) || 1 }; });
    var url = (window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js';
    var chain = Promise.resolve(null);
    jobs.forEach(function (job, i) {
      chain = chain.then(function () {
        var body = { id: job.id, quantity: job.quantity, selling_plan: job.selling_plan };
        if (drawer && i === jobs.length - 1) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
      });
    });
    chain.then(function (state) {
      try { sessionStorage.setItem('nl-just-subscribed', '1'); } catch (err) {}
      if (drawer && state && state.sections && typeof drawer.renderContents === 'function') { drawer.renderContents({ id: null, sections: state.sections }); setTimeout(celebrate, 60); }
      else window.location.reload();
    }).catch(function () { window.location.reload(); });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nl-upgrade]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');
    var drawer = btn.closest('cart-drawer');
    var body = {
      line: parseInt(btn.dataset.line, 10),
      quantity: parseInt(btn.dataset.qty, 10) || 1,
      selling_plan: parseInt(btn.dataset.plan, 10)
    };
    if (drawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: null, sections: state.sections });
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); });
  });
})();
